import React from 'react';

import PropTypes from 'prop-types';

import {useComponent} from './hooks/useComponent';

import './SearchDay.less';

function SearchDay(props) {
    const {
        className,
        day,
        ariaLabelDate
    } = useComponent(props);

    return (
        <div className={className} aria-hidden>
            {day}
            <p className="hidden">
                {ariaLabelDate}
            </p>
        </div>
    );
}

SearchDay.propTypes = {
    ariaLabelDate: PropTypes.string,
    dateString: PropTypes.string,
    day: PropTypes.number,
    isPast: PropTypes.bool,
    isToday: PropTypes.bool
};

SearchDay.defaultProps = {
    ariaLabelDate: '',
    dateString: '',
    day: 0,
    isPast: false,
    isToday: false
};

SearchDay.canClick = function canClick(props) {
    const {
        dayData: {
            inPast
        },
        isPast
    } = props;

    return !(isPast || inPast);
};

// SearchDay.whyDidYouRender = true;

export {SearchDay};
